import React from "react";
import { Container, Form } from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { HOUSING_REQUIRED_FIELDS } from "./CONSTANT";
import * as Yup from "yup";
import HousingForm from "./HousingForm";
import { addHousing } from "../../../api/housing";

const TYPES = {
  'select': null,
  'add-more': [],
  'checkbox': false,
  'file' : null,
  'date': null
}

const initialValues = {};
const FIELDS_VALIDATION = {};

HOUSING_REQUIRED_FIELDS.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] || "";
  if (f.type == "file") {
    FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
      "This Field Is Required"
    );
  } else if (f.type == "select" && f.isMulti) {
    FIELDS_VALIDATION[f.key] = Yup.array();
  } else {
    FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
  }
});

const AddHousing = () => {
  const { t } = useTranslation();
  let navigate = useHistory();

  const { setData, loading, error, success } = useResponse(addHousing, () => {
    navigate.goBack()
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {...initialValues, isActive: true},
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (values) => {
      let data = new FormData();

      Object.keys(values).map(key => {
        if (typeof values[key] === 'boolean'){
            data.append(key, values[key])
        } else if(values[key]){
            data.append(key, values[key])
        }
    })
      
      setData({ type: "add", data });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Housing")}
            breadcrumbItem={t("Add") + " " + t("House")}
          />

          <Form
            className="needs-validation"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <HousingForm validation={validation} />

            <FormButtonHandler btnTxt="Add" loading={loading} />

            <ResultHandler
              error={error}
              success={success}
              successMsg={"Created Successfully!"}
            />
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddHousing;
